<template>
  <div>
    <list
      row-key="UserId"
      ref="list"
      unit="留宿报名"
      :page="page"
      :query-params="params"
      :show-checkbox="$permission.canWrite()"
      :show-query="showQuery"
      :get-data-func="api.list"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
        <el-button size="mini" class="filter-item" type="success" plain @click="onExport">导出</el-button>
      </template>
      <template slot="query">
        <el-form-item label="留宿日期">
          <el-date-picker
            v-model="params.Date"
            placeholder="请选择日期"
            clearable
            style="width:184px;"
            value-format="yyyy-MM-dd"
          />
        </el-form-item>
        <el-form-item label="学期名称">
          <el-select v-model="params.TermId" @change="termChange">
            <el-option
              v-for="item in termList"
              :key="item.TermId"
              :value="item.TermId"
              :label="item.TermName"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="年级">
          <el-select v-model="params.GradeId" @change="getClass" clearable>
            <template v-for="(i,index) in grades">
              <el-option :key="index" :value="i.GradeId" :label="i.Grade"></el-option>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item label="班级">
          <el-select v-model="params.ClassId" clearable>
            <template v-for="(i,index) in classes">
              <el-option :key="index" :value="i.ClassId" :label="i.ClassName"></el-option>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item label="学生姓名">
          <el-input v-model="params.FullName" placeholder="请填写姓名"></el-input>
        </el-form-item>
        <el-form-item label="宿舍号">
          <el-input size="mini" v-model="params.Dormitory" placeholder="请填写宿舍号" clearable/>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="params.Status" clearable size="mini">
            <el-option :value="0" label="待审"></el-option>
            <el-option :value="1" label="通过"></el-option>
            <el-option :value="2" label="不通过"></el-option>
            <el-option :value="3" label="取消"></el-option>
            <el-option :value="4" label="请假"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label-width="17px">
          <el-checkbox v-model="params.Week" @change="query()">本周</el-checkbox>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="FullName" label="姓名" min-width="60">
          <template slot-scope="{row}">
            <span :style="row.Status==3||row.Status==4?'color:#bbb;':''">{{row.FullName}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="Dormitory" label="宿舍号" min-width="70"/>
        
        <el-table-column label="留宿日期" :width="isMB?'95':'170'">
          <template slot-scope="{row}">
            <span>{{$commonJs.toDateString(row.StartDate)}}</span>
            -
            <span>{{$commonJs.toDateString(row.EndDate)}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="DisciplinePoint" label="本周期扣分值" />
        <el-table-column prop="LastStayRegId" label="上期是否留宿">
          <template slot-scope="{row}">
            {{row.LastStayRegId?"是":"否"}}
          </template>
        </el-table-column>
        <el-table-column prop="Grade" label="年级" />
        <el-table-column prop="Class" label="班级" />
        <el-table-column prop="FileUrl" label="附件" width="80" align="center">
          <template slot-scope="{row}">
            <template v-if="row.FileUrl">
              <el-button type="text" v-if="isImg(row.FileUrl)" @click="viewImg(row.FileUrl)">查看</el-button>
              <el-button type="text" v-else @click="dl(row)">下载</el-button>
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="Status" label="状态" width="60" align="center" fixed="right">
          <template slot-scope="{row}">
            <span v-if="row.Status==0">待审</span>
            <span v-else-if="row.Status==1">通过</span>
            <span v-else-if="row.Status==2">不通过</span>
            <span v-else-if="row.Status==3">取消</span>
            <span v-else-if="row.Status==4">请假</span>
          </template>
        </el-table-column>

        <slot name="column"></slot>
      </template>
    </list>
    <el-dialog title="查看图片" :visible.sync="dialogVisible" :append-to-body="true">
      <img width="100%" :src="dialogImageUrl" alt />
      <div slot="footer">
        <el-button @click="dialogVisible=false">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";

export default {
  mixins: [listMixin],
  components: { list },
  data() {
    return {
      api: require("@/api/attendance/reg").default,
      grade_api: require("@/api/ed/grade").default,
      class_api: require("@/api/ed/class").default,
      term_api: require("@/api/ed/term").default,
      isMB: this.$store.state.isMB,
      params: {
        TermId: null,
        Date: "",
        GradeId: null,
        ClassId: null,
        FullName: null,
        ClassName: "",
        Dormitory: "",
        Status: null,
        Temporary: 0,
        Week: true,
      },
      termList: [],
      grades: [],
      classes: [],
      dialogVisible: false,
      dialogImageUrl: "",
      disciplineList: [],
    };
  },
  mounted() {
    let loginInfo = JSON.parse(localStorage.getItem("loginInfo"));
    this.params.TermId = loginInfo.TermId;
    this.term_api.list().then((res) => {
      if (res.Data && res.Data.length > 0) {
        this.termList = res.Data;
        if (this.params.TermId) {
          res.Data.forEach((e) => {
            if (e.TermId == this.params.TermId) {
              this.params.TermName = e.TermName;
            }
          });
        } else {
          this.params.TermId = res.Data[0].TermId;
        }
        this.$refs.list.initQueryParams.TermId = this.params.TermId;
        this.query({ TermId: this.params.TermId });
      }
    });
    this.getGrade();
  },
  methods: {
    getGrade() {
      this.params.GradeId = null;
      this.grade_api.list().then((res) => {
        this.grades = res.Data;
      });
    },
    termChange(e) {
      this.params.ClassName = "";
      this.params.ClassId = null;
      this.sectionList = [];
      this.getClass();
      this.getGrade();
      this.query({
        TermId: e,
      });
    },
    getClass() {
      this.params.ClassId = null;
      if (!this.params.GradeId) {
        this.classes = [];
        return;
      }
      var params = { GradeId: this.params.GradeId, TermId: this.params.TermId };
      this.class_api.list(params).then((res) => {
        this.classes = res.Data;
      });
    },
    change(Ids,type) {
      this.api[type]({ Ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("操作成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
    onExport() {
      this.api.export(this.$commonJs.obj.removeNullKey(this.$refs.list.tempQueryParams));
    },
    viewImg(url) {
      this.dialogImageUrl = '/api' + url;
      this.dialogVisible = true;
    },
    dl(item) {
      // window.open('/api'+item.FileUrl);
      const elink = document.createElement("a");
      elink.download = item.FileName||item.FileUrl.split("/")[4];
      elink.style.display = "none";
      elink.target = "_blank";
      elink.href = location.origin + "/api" + item.FileUrl;
      document.body.appendChild(elink);
      elink.click();
      URL.revokeObjectURL(elink.href); // 释放URL 对象
      document.body.removeChild(elink);
    },
    isImg(url) {
      var ex = url.split(".")[1];
      return ex=='jpg'||ex=='png'||ex=='jpeg';
    },
  }
};
</script>